<template>
  <div class="worCard">
    <div
      class="m-smallBan"
      :style="{
        backgroundImage: 'url(' + require('../../assets/img/ico_24.jpg') + ')'
      }"
    >
      <div class="m-smallBan-cap">
        {{ menu.subTitle }}
      </div>
    </div>
    <div class="g-box">
      <div v-for="(item, index) in list" :key="index" class="list-item">
        <div class="list-item-cap">{{ item.title }}</div>
        <div class="list-item-text" v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      pageSize: 10000000
    };
  },
  components: {},
  mounted() {},
  methods: {
    async init() {
      this.params = this.$route.params;
      await this.getListAndInfo();
    }
  }
};
</script>
<style lang="less">
.worCard {
  padding-bottom: 100px;
  .list-item {
    margin-top: 50px;
    padding-left: 14px;
  }
  .list-item-cap {
    color: #606060;
    font-size: 18px;
    position: relative;
    &:after {
      content: "";
      position: absolute;
      left: -14px;
      top: 50%;
      width: 4px;
      height: 16px;
      margin-top: -8px;
      background: rgba(82, 151, 224, 1);
    }
  }
  .list-item-text {
    color: #979797;
    font-size: 16px;
    line-height: 1.8;
    margin-top: 8px;
  }
}
</style>
